import { BOX_REQUIREMENTS } from '@developerz/domain';
import type { JSX } from 'solid-js';
import { t } from '../i18n';

// What a box must BE to join (plan 102 slice 05, decision 7), rendered off the
// domain's ONE value, `BOX_REQUIREMENTS` — the constant the join script's preflight
// and the server's enroll gate (`checkBoxEnrollSpecFloors`) refuse under. The
// sentence is ours (`t()`); every fact in it is the domain's, so no number or OS
// name here can drift from what the join actually checks. `sudo` has one value
// (`passwordless`), which the sentence names.

export function BoxRequirements(): JSX.Element {
  const r = BOX_REQUIREMENTS;
  const arch = new Intl.ListFormat(t.locale, { type: 'disjunction' }).format(r.architectures);
  return (
    <p class="field__desc" data-testid="box-requirements">
      {t('fleet.connect.requirements', {
        os: r.osName,
        arch,
        ram: r.ramNominalGb,
        disk: r.diskAvailableFloorGib,
      })}
    </p>
  );
}
